import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import { perfMarkTransitionOutDone, perfTime } from '../utils/perf'
import { classesInjection } from '../utils/transitions'

const duration = 0.15

class FadeTransition extends Highway.Transition {
  in ({ from, to, done }) {
    const end = perfTime('transition.in')

    const endClasses = perfTime('transition.in classesInjection')
    classesInjection(to)
    endClasses()

    const endRemove = perfTime('transition.in from.remove')
    from.remove()
    endRemove()

    gsap.fromTo(
      to,
      { opacity: 0 },
      {
        opacity: 1,
        duration,
        onComplete: () => {
          end()
          done()
        }
      }
    )
    return this
  }

  out ({ from, done }) {
    const end = perfTime('transition.out')

    gsap.fromTo(
      from,
      { opacity: 1 },
      {
        opacity: 0,
        duration,
        onComplete: () => {
          perfMarkTransitionOutDone()
          end()
          done()
        }
      }
    )
    return this
  }
}

export default FadeTransition
